import Http from "@/commons/Http";

const path = '/api/v2/sigef';

export default {

  async salvar(fichaId, dados) {
    return await Http.post(`${path}/${fichaId}/poligono`, dados);
  },

  async listarTipoSig(categoria){
    return await Http.get(`${path}/listar-tipo-sig/${categoria}`);
  },

  async buscarSobreposicoes(indicadorRealId) {
    return await Http.get(`${path}/${indicadorRealId}/poligono/sobreposicoes`);
  },

  async atualizarEnviadoOnr(indicadorRealId, enviado) {
    return await Http.post(`${path}/${indicadorRealId}/poligono/enviado-onr`, {enviado});
  },

  async uploadQrCode(indicadorRealId, file) {
    const formData = new FormData();
    formData.append('file', file);
    return await Http.post(`${path}/${indicadorRealId}/poligono/qr-code`, formData, {
      headers: { 'Content-Type': undefined }
    });
  },

  async excluirQrCode(indicadorRealId) {
    return await Http.delete(`${path}/${indicadorRealId}/poligono/qr-code`);
  }

}
